export const KeycloakConstants = {
  BEESHEETS_APP_TOKEN: 'beesheets-app-token',
  LOGIN_REQUIRED: 'login-required',
  S256: 'S256',
  ROLE: 'role',
  IS_ADMIN: 'isAdmin',
  ID: 'id',
};
